// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7h-0";
export var startPickingButton = "_7h-1";